export { default as routesEn } from './localeEn';
export { default as routesEs } from './localeEs';
export { default as routesPt } from './localePt';
